import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SaidaEstoqueListarComponent } from './saida-estoque-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: SaidaEstoqueListarComponent}
  ])],
  exports: [RouterModule]
})
export class SaidaEstoqueListarRoutingModule { }
